import type { TOC } from '@ember/component/template-only';
import { notEq } from 'ember-truth-helpers';
import GeneralIconWithTooltip from 'lumen/components/general/icon-with-tooltip';

interface HotelOverviewDashboardUpdateIndicatorSignature {
  Args: {
    updateIndicatorContent: unknown;
  };
}

const HotelOverviewDashboardUpdateIndicator = <template>
  {{! @glint-nocheck: not typesafe yet }}
  {{#if (notEq @updateIndicatorContent.isOutOfSync null)}}
    <GeneralIconWithTooltip
      @iconName={{if @updateIndicatorContent.isOutOfSync "sync-disabled" ""}}
      @side="top"
      @tooltipContent={{@updateIndicatorContent.formattedLastUpdatedTimestamp}}
    />
  {{/if}}
</template> satisfies TOC<HotelOverviewDashboardUpdateIndicatorSignature>;

export default HotelOverviewDashboardUpdateIndicator;
